import { lazy } from 'react'
import type { RouteObject } from 'react-router-dom'

const ForumListPage = lazy(() =>
  import('../pages/forum').then((m) => ({ default: m.ForumListPage })),
)
const ForumBoardPage = lazy(() =>
  import('../pages/forum').then((m) => ({ default: m.ForumBoardPage })),
)
const TopicPage = lazy(() => import('../pages/forum').then((m) => ({ default: m.TopicPage })))

// SOCIAL-LAYER (Forum) — business-owned discussion forums (workspace-service).
export const forumRoutes: RouteObject[] = [
  { path: '/forum', element: <ForumListPage /> },
  { path: '/forum/:forumId', element: <ForumBoardPage /> },
  { path: '/forum/:forumId/topics/:topicId', element: <TopicPage /> },
]
